import { MARQUEE_AREAS } from './constants'
import RewardCard from '../shared/RewardCard'
import styles from './styles.module.scss'

const HeroSection = (): JSX.Element => (
  <section className={styles.hero}>
    <div className={`${styles.content} ${styles.heroGrid}`}>
      <div>
        <span className={styles.heroBadge}>
          <span />
          全国の店舗・施設を募集中の紹介キャンペーン
        </span>
        <h1 className={styles.displayTitle}>
          日本全国
          <br />
          <span>荷物預かりマップ</span>
          <br />
          を埋めよう
        </h1>
        <p className={styles.heroLead}>
          あなたの紹介が、コインロッカー難民を救う。知っているお店を
          <br />
          紹介して、荷物を預けられる場所を全国に増やしませんか？
        </p>
        <div className={styles.heroCta}>
          <a
            href="#form"
            className={`${styles.button} ${styles.primaryButton} ${styles.largeButton}`}
          >
            紹介者登録をする
          </a>
          <a href="#map" className={`${styles.button} ${styles.ghostButton} ${styles.largeButton}`}>
            不足エリアを見る
          </a>
        </div>
        <p className={styles.heroNote}>
          ※
          紹介者・導入店舗それぞれに特典をお支払いします。本キャンペーンは予告なく終了・内容を変更する場合があります。
        </p>
      </div>
      <div className={styles.rewardStack}>
        <RewardCard />
        <RewardCard store />
      </div>
    </div>
    <div className={styles.marquee} aria-hidden="true">
      <div className={styles.marqueeTrack}>
        {[...MARQUEE_AREAS, ...MARQUEE_AREAS].map((area, index) => (
          <span key={`${area}-${index}`}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2 c-4 0 -7.2 3.2 -7.2 7.2 0 5 7.2 12.8 7.2 12.8 s7.2 -7.8 7.2 -12.8 C19.2 5.2 16 2 12 2 z" />
              <circle cx="12" cy="9.2" r="2.6" />
            </svg>{' '}
            {area} <b>・</b>
          </span>
        ))}
      </div>
    </div>
  </section>
)

export default HeroSection
